/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ParentEventEntryResponse = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        teamId: {
            type: 'number',
            isRequired: true,
        },
        eventType: {
            type: 'EventTypeEnum',
            isRequired: true,
        },
        entries: {
            type: 'array',
            contains: {
                type: 'EventEntryResponse',
            },
            isRequired: true,
        },
    },
} as const;
